module.exports = __webpack_public_path__ + "files/deb250b85f3cd0f4c9f2d522451753ff.svg";